import { validateBasicFrenchDate } from '@/helpers'

const basicFrenchDateValidator = (value) => {
  return validateBasicFrenchDate(value)
}

export default basicFrenchDateValidator
